import React from 'react';
import Divider from 'material-ui/Divider'
import FormPageSchedule from './FormPageSchedule'
import FontIcon from 'material-ui/FontIcon';
import { updateObject } from 'helpers/objectHelpers';
import { compose } from 'recompose';
import { isEmpty, last } from 'lodash'
import { removeItemArrayByIndex, updateItemArrayByIndex, addItemToArray } from 'helpers/arrayHelpers'
import CustomFlatButton from 'components/Button/CustomFlatButton'
import muiThemeable from 'material-ui/styles/muiThemeable'

const styles = {
  formTitle: {
    width: '20%',
    margin: 20,
    paddingRight: 20,
    display: 'flex',
    flexDirection: 'column',
    borderRight: 'solid 1px lightgrey',
  },
  formLinkWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  currentPage: {
    color: 'darkgrey',
  },
  pageSchedule: {
    width: '65%',
    margin: 20,
  },
  button: {
    paddingTop: 25,
    paddingLeft: 40,
  },
  addButton: {
    border: '1px dashed rgba(0, 0, 0, 0.3)',
    magin: 'auto',
    width: '100%',
    color: 'rgba(0, 0, 0, 0.3)',
    lineHeight: '14px',
  },
  addButtonIcon: {
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.3)',
    lineHeight: '14px',
  },
  deleteButton: {
    marginTop: 20,
    width: '15%',
    textAlign: 'center',
    lineHeight: '14px',
  },
  deleteButtonIcon: {
    fontSize: '14px',
    lineHeight: '14px',
  },
  scheduleTitle: {
    display: 'flex',
  },
  deleteTitle: {
    width: '5%',
  },
  startTitle: {
    width: '56%',
    color: 'grey',
    paddingLeft: 2,
  },
  selectPageTitle: {
    width: '38%',
    color: 'grey',
  },
  page: {
    paddingRight: 3,
    paddingTop: 27,
    fontSize: 16,
    color: 'lightGrey',
  },
};

const FormStaticPage = compose(
  muiThemeable(),
)(({
  staticPage,
  pages,
  onSubmit,
  valuePage,
  isEditing,
  setEditing,
  hideError,
  muiTheme,
  title,
}) => {
  const updateStaticPage = ({ value, key }) => onSubmit(updateObject(staticPage, { [key]: value }))

  const handlePageScheduleChange = (val, index) => {
    updateStaticPage({ value: updateItemArrayByIndex(staticPage.pageSchedule, index, () => val), key: 'pageSchedule' })
  }

  const handleRemovePageSchedule = (index) => {
    const result = removeItemArrayByIndex(staticPage.pageSchedule, index)
    return updateStaticPage({ value: result, key: 'pageSchedule' })
  }

  const getCurrentPage = () => {
    const currentDate = new Date()
    const matchedPages = staticPage.pageSchedule.filter((item) => (item.start <= currentDate.getTime() && currentDate.getTime() <= item.end))
    if (isEmpty(matchedPages)) {
      return ''
    }
    matchedPages.sort((a, b) => (
      a.start - b.start
    ))
    return last(matchedPages).pageId
  }
  return (
    <div style={{ display: 'flex', textAlign: 'left' }}>
      <div style={styles.formTitle}>
        <h3 style={styles.label}>{title}</h3>
        <div style={styles.currentPage}>
          Current Page:{' '}
          {
            !isEmpty(getCurrentPage()) ?
              <span style={{ color: muiTheme.palette.accent1Color }}>{getCurrentPage()}</span>
              :
              'None'
          }

        </div>
      </div>
      <div style={styles.pageSchedule}>
        <div style={styles.scheduleTitle}>
          <small style={styles.deleteTitle} />
          <small style={styles.startTitle}>Start</small>
          <small style={styles.selectPageTitle}>Select Page</small>
        </div>
        { staticPage.pageSchedule && staticPage.pageSchedule.length > 0 &&
          staticPage.pageSchedule.map((item, i) => (
            <FormPageSchedule
              index={i}
              schedule={item}
              valuePage={valuePage}
              isEditing={isEditing}
              setEditing={setEditing}
              onSubmit={onSubmit}
              pages={pages}
              handlePageScheduleChange={(value) => handlePageScheduleChange(value, i)}
              onRemove={() => handleRemovePageSchedule(i)}
              hideError={hideError}
            />
          ))
        }
        <CustomFlatButton
          style={styles.addButton}
          label="Add Schedule"
          onTouchTap={() => {
            updateStaticPage({ value: addItemToArray(staticPage.pageSchedule, {}), key: 'pageSchedule' })
            setEditing(true)
            hideError()
          }}
          icon={
            <FontIcon
              className="fa fa-plus"
              color="black"
              style={styles.addButtonIcon}
            />
          }
        />
      </div>
      <div style={styles.deleteButton} />
      <Divider />
    </div>
  );
});

FormStaticPage.propTypes = {};
FormStaticPage.defaultProps = {
  staticPage: { pageSchedule: [] },
  pages: [],
  onChange: () => {},
  hideError: () => {},
};

export default FormStaticPage



// WEBPACK FOOTER //
// ./src/components/forms/FormStaticPage.js